import Modal from "@shared/components/ui-kit/overlays/Modal/Modal.web";
import Button from "@ui-kit/form/Button/Button.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { HowCreditsWorkModalSharedProps } from "./HowCreditsWorkModal.props";

export default function HowCreditsWorkModal({
  isOpen,
  onClose,
}: HowCreditsWorkModalSharedProps): JSX.Element {
  const { t } = useTranslation("exchanges");

  return (
    <Modal
      size="3xl"
      isOpen={isOpen}
      onClose={onClose}
      variant="informational"
      data-testid="how-credits-work-modal"
    >
      <Modal.Header onClose={onClose}>
        <Text fontSize="xl" fontWeight="bold">
          {t("How credits work")}
        </Text>
      </Modal.Header>

      <Modal.Body>
        <Flex direction="column" gap="xs">
          <Text size="lg" fontWeight="bold">
            {t("Exchange credits")}
          </Text>
          <Text size="sm">
            {t(
              "The temporary Exchange Credits will expire within the hour if you cannot find suitable tickets and your original tickets will remain valid. Once your Exchange Credits have been used, you will not have access to your original tickets. Please note that donations are non-refundable."
            )}
          </Text>
        </Flex>
      </Modal.Body>

      <Modal.Footer>
        <Button.Solid
          width={{
            base: "100%",
            md: "fit-content",
          }}
          onClick={onClose}
          colorPalette="primary"
          data-testid="how-credits-work-modal-close-button"
        >
          {t("Close")}
        </Button.Solid>
      </Modal.Footer>
    </Modal>
  );
}
